import { Link, useLocation } from 'react-router-dom';
import artesaLogo from '@/assets/artesa_logo.webp';
import NewsletterForm from '@/components/NewsletterForm';
import { useOfertaCompleto } from '@/contexts/OfertaContext';

const PublicFooter = () => {
  const completo = useOfertaCompleto();
  const { pathname } = useLocation();

  // Mostra newsletter na landing, central de conteúdo e detalhes de conteúdo
  let newsletterSource: 'landing' | 'central-conteudo' | 'conteudo-detalhe' | null = null;
  if (pathname === '/' || pathname === '/index') newsletterSource = 'landing';
  else if (pathname === '/central-de-conteudo') newsletterSource = 'central-conteudo';
  else if (pathname.startsWith('/conteudos/') || pathname.startsWith('/categorias/')) {
    newsletterSource = 'conteudo-detalhe';
  }

  return (
    <footer className="border-t border-ink-100 bg-canvas-alt">
      {newsletterSource && (
        <div className="border-b border-ink-100 bg-background">
          <div className="container py-8 md:py-10">
            <div className="grid md:grid-cols-2 gap-6 items-center max-w-4xl mx-auto">
              <div>
                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground mb-1">
                  Receba inspirações e dicas no seu e-mail
                </h3>
                <p className="text-sm text-ink-500 font-body">
                  Conteúdo curado para artesãs que querem organizar e valorizar o próprio trabalho.
                </p>
              </div>
              <NewsletterForm source={newsletterSource} />
            </div>
          </div>
        </div>
      )}

      <div className="container py-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center mb-3">
              <img
                src={artesaLogo}
                alt="Artesã"
                width={80}
                height={24}
                loading="lazy"
                decoding="async"
                className="h-6 w-auto object-contain"
              />
            </Link>
            <p className="text-sm text-ink-500 font-body leading-relaxed">
              Registre, acompanhe, organize e valorize o seu trabalho manual.
            </p>
          </div>

          <div>
            <h3 className="ds-label mb-3">Navegação</h3>
            <ul className="space-y-2 text-sm text-ink-500 font-body">
              <li><Link to="/login" className="hover:text-primary transition-colors">Entrar</Link></li>
              <li><Link to="/cadastro" className="hover:text-primary transition-colors">Criar conta</Link></li>
              <li><Link to="/planos" className="hover:text-primary transition-colors">{completo ? 'Preço' : 'Planos'}</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="ds-label mb-3">Produto</h3>
            <ul className="space-y-2 text-sm text-ink-500 font-body">
              <li><Link to="/funcionalidades" className="hover:text-primary transition-colors">Funcionalidades</Link></li>
              {!completo && <li><Link to="/comparativo-de-planos" className="hover:text-primary transition-colors">Comparativo</Link></li>}
              <li><Link to="/central-de-conteudo" className="hover:text-primary transition-colors">Central de conteúdo</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="ds-label mb-3">Institucional</h3>
            <ul className="space-y-2 text-sm text-ink-500 font-body">
              <li><Link to="/quem-somos" className="hover:text-primary transition-colors">Quem somos</Link></li>
              <li><Link to="/contato" className="hover:text-primary transition-colors">Contato</Link></li>
              <li><Link to="/faq" className="hover:text-primary transition-colors">Ajuda</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="ds-label mb-3">Legal</h3>
            <ul className="space-y-2 text-sm text-ink-500 font-body">
              <li><Link to="/politica-de-privacidade" className="hover:text-primary transition-colors">Privacidade</Link></li>
              <li><Link to="/termos-de-uso" className="hover:text-primary transition-colors">Termos de uso</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-ink-100 text-center text-xs text-ink-500 font-body">
          © {new Date().getFullYear()} Artesã. Todos os direitos reservados.
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
